import { z } from 'zod';
import type { JSONContent } from '@tiptap/core';

export const JSONContentSchema: z.ZodType<JSONContent> = z.custom<JSONContent>();

// JSON Schema
export const literalJsonSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
export type LiteralJson = z.infer<typeof literalJsonSchema>;

// Define the recursive JSON type
export type Json = LiteralJson | { [key: string]: Json } | Json[];

// Create the recursive schema with proper typing for Zod v4
const baseJsonSchema: z.ZodType<Json> = z.union([
  literalJsonSchema,
  z.lazy(() => z.array(baseJsonSchema)),
  z.lazy(() => z.record(z.string(), baseJsonSchema)),
]);

export const JSONSchema: z.ZodType<Json> = baseJsonSchema;

// Input rules for the Tiptap resizable media extension. Match markdown-style
// image/video syntax so pasting or typing it converts to a media node. Shared
// by the admin editor and the student runtime so both parse media identically.
export const IMAGE_INPUT_REGEX = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;

export const VIDEO_INPUT_REGEX = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/;
